export const CHANTIERS = {
  "renovation-facade-bernay": {
    slug: "renovation-facade-bernay",
    ville: "Bernay",
    titre: "Rénovation de façade à Bernay",
    seoTitle: "Rénovation de façade à Bernay | Brique & enduit – DMZ Normandie",
    seoDesc: "Chantier réel à Bernay : décapage, reprise de maçonnerie, rénovation d'une façade et finitions en brique. DMZ Normandie, devis gratuit.",
    subtitle: "Une façade dégradée reprise étape par étape en centre-ville de Bernay, du diagnostic jusqu'aux finitions.",
    description: "Ce chantier de Bernay montre la transformation complète d'une façade fatiguée : état avant travaux, décapage, reprise de la maçonnerie puis façade rénovée. Les photos présentées sont toutes issues de ce chantier réel.",
    materiaux: ["Brique", "Enduit de façade", "Mortier de rejointoiement"],
    etapes: ["Diagnostic de l'état de la façade", "Décapage de l'enduit dégradé", "Reprise de la maçonnerie existante", "Rejointoiement et réparation des zones fatiguées", "Application de l'enduit et finitions des encadrements"],
    photos: [
      { img: "/realisations/facade-avant-bernay.webp", alt: "Façade dégradée avant rénovation à Bernay par DMZ Normandie" },
      { img: "/realisations/facade-decapage-bernay.webp", alt: "Décapage d'une façade ancienne à Bernay par DMZ Normandie" },
      { img: "/realisations/facade-pendant-bernay.webp", alt: "Façade en cours de rénovation à Bernay par DMZ Normandie" },
      { img: "/realisations/facade-apres-bernay.webp", alt: "Façade rénovée avec encadrements en brique à Bernay par DMZ Normandie" },
      { img: "/realisations/renovation-facade-bernay.webp", alt: "Rénovation de façade en brique à Bernay par DMZ Normandie" },
    ],
    services: ["renovation-bernay", "rejointoiement", "maconnerie-bernay"],
    villesProches: ["Menneval", "Serquigny", "Fontaine-l'Abbé"],
  },
  "reprise-linteau-bernay": {
    slug: "reprise-linteau-bernay",
    ville: "Bernay",
    titre: "Reprise de linteau en brique à Bernay",
    seoTitle: "Reprise de linteau à Bernay | Réparation brique – DMZ Normandie",
    seoDesc: "Reprise réelle d'un linteau et de briques au-dessus d'une fenêtre à Bernay : étaiement, dépose et remontée soignée par DMZ Normandie.",
    subtitle: "Une réparation ciblée au-dessus d'une baie, avec reprise du linteau et remise en place de la maçonnerie.",
    description: "À Bernay, DMZ Normandie est intervenue sur une zone fragilisée au-dessus d'une fenêtre. Le linteau et les briques ont été repris avec précision afin de consolider la façade tout en conservant son aspect.",
    materiaux: ["Briques existantes et briques de reprise", "Mortier", "Linteau"],
    etapes: ["Sécurisation et étaiement de la zone", "Dépose des éléments fragilisés", "Reprise du linteau", "Remontée brique par brique", "Joints et finitions autour de la baie"],
    photos: [
      { img: "/realisations/reprise-linteau-bernay.webp", alt: "Reprise d'un linteau en brique à Bernay par DMZ Normandie" },
    ],
    services: ["renovation-bernay", "rejointoiement", "construction-murs"],
    villesProches: ["Thiberville", "Menneval", "Serquigny"],
  },
  "maconnerie-brique-bernay": {
    slug: "maconnerie-brique-bernay",
    ville: "Bernay",
    titre: "Maçonnerie brique à Bernay",
    seoTitle: "Maçonnerie brique à Bernay | Murs & linteaux – DMZ Normandie",
    seoDesc: "Montage réel de murs en brique à Bernay : linteaux, ouvertures et finitions des baies par DMZ Normandie. Devis gratuit dans l'Eure.",
    subtitle: "Montage de murs en brique avec linteaux et ouvertures, dans le respect du bâti normand.",
    description: "Ce chantier réalisé à Bernay illustre le montage soigné de murs en brique : alignement, linteaux et finition des baies. Une maçonnerie traditionnelle adaptée aux constructions et rénovations locales.",
    materiaux: ["Brique", "Mortier", "Linteaux"],
    etapes: ["Implantation et contrôle des alignements", "Montage des murs en brique", "Mise en place des linteaux", "Réalisation des ouvertures", "Joints et finitions"],
    photos: [
      { img: "/realisations/mur-brique-bernay.webp", alt: "Construction d'un mur en brique à Bernay par DMZ Normandie" },
    ],
    services: ["maconnerie-bernay", "construction-murs", "gros-oeuvre"],
    villesProches: ["Thiberville", "Menneval", "Caorches-Saint-Nicolas"],
  },
  "terrasse-carrelee-bernay": {
    slug: "terrasse-carrelee-bernay",
    ville: "Bernay",
    titre: "Terrasse carrelée à Bernay",
    seoTitle: "Terrasse carrelée à Bernay | Dalle & extérieur – DMZ Normandie",
    seoDesc: "Chantier réel à Bernay : préparation du support, dalle et pose d'une terrasse carrelée grand format par DMZ Normandie.",
    subtitle: "Une terrasse extérieure carrelée, préparée pour un usage durable et une finition propre.",
    description: "À Bernay, nous avons préparé le support, réalisé la dalle et posé un carrelage extérieur grand format. Le résultat offre une terrasse prête à vivre, avec des lignes nettes et une surface régulière.",
    materiaux: ["Dalle béton", "Carrelage extérieur grand format", "Mortier-colle"],
    etapes: ["Préparation et réglage du support", "Réalisation ou reprise de la dalle", "Traçage et calage de la pose", "Pose du carrelage extérieur", "Joints et contrôle des finitions"],
    photos: [
      { img: "/realisations/terrasse-carrelee-bernay.webp", alt: "Terrasse carrelée réalisée à Bernay par DMZ Normandie" },
    ],
    services: ["dalles-beton", "beton-amenagements-exterieurs", "maconnerie-bernay"],
    villesProches: ["Menneval", "Serquigny", "Saint-Martin-du-Tilleul"],
  },
  "parement-brique-beuzeville": {
    slug: "parement-brique-beuzeville",
    ville: "Beuzeville",
    titre: "Parement brique à Beuzeville",
    seoTitle: "Parement brique à Beuzeville | Façade & pignon – DMZ Normandie",
    seoDesc: "Pose réelle d'un parement brique à Beuzeville : façade, pignon, joints réguliers et finitions de rives par DMZ Normandie.",
    subtitle: "Un habillage complet en parement brique, réalisé sur façade et pignon avec des joints réguliers.",
    description: "Ce chantier de Beuzeville montre la pose d'un parement brique sur plusieurs faces de la maison. Les photos réelles présentent la façade, le pignon et le niveau de finition des joints.",
    materiaux: ["Parement brique", "Mortier-colle", "Mortier de jointoiement"],
    etapes: ["Contrôle et préparation du support", "Traçage des lignes de pose", "Pose rang par rang", "Finitions des angles et des rives", "Jointoiement et nettoyage"],
    photos: [
      { img: "/realisations/parement-brique-beuzeville-facade.webp", alt: "Parement brique sur façade à Beuzeville par DMZ Normandie" },
      { img: "/realisations/parement-brique-beuzeville-pignon.webp", alt: "Parement brique sur pignon à Beuzeville par DMZ Normandie" },
      { img: "/realisations/parement-brique-beuzeville-mur.webp", alt: "Détail de pose d'un parement brique à Beuzeville par DMZ Normandie" },
    ],
    services: ["parement-brique", "construction-murs", "maconnerie-beuzeville"],
    villesProches: ["Pont-Audemer", "Bernay", "ouest de l'Eure"],
  },
  "amenagement-paves-louviers": {
    slug: "amenagement-paves-louviers",
    ville: "Louviers",
    titre: "Bordures, escalier et pavés à Louviers",
    seoTitle: "Pavés et bordures à Louviers | Aménagement extérieur – DMZ Normandie",
    seoDesc: "Aménagement extérieur réel à Louviers : escalier bordé de pavés, bordures et muret de soutènement par DMZ Normandie.",
    subtitle: "Un extérieur structuré avec un escalier bordé de pavés, des bordures et un muret de soutènement.",
    description: "À Louviers, DMZ Normandie a réalisé un aménagement extérieur complet : pose de pavés et bordures, création d'un escalier et montage d'un muret de soutènement en parpaings.",
    materiaux: ["Pavés", "Bordures", "Parpaings"],
    etapes: ["Préparation et réglage du terrain", "Pose des bordures", "Pose des pavés", "Montage du muret de soutènement", "Contrôle des niveaux et finitions"],
    photos: [
      { img: "/realisations/bordures-escalier-paves-louviers.webp", alt: "Bordures en escalier et pavés à Louviers par DMZ Normandie" },
    ],
    services: ["beton-amenagements-exterieurs", "construction-murs", "maconnerie-louviers"],
    villesProches: ["Évreux", "Conches-en-Ouche", "sud de l'Eure"],
  },
  "construction-maison-louviers": {
    slug: "construction-maison-louviers",
    ville: "Louviers",
    titre: "Construction d'une maison en parpaings à Louviers",
    seoTitle: "Construction maison à Louviers | Gros œuvre – DMZ Normandie",
    seoDesc: "Gros œuvre réel à Louviers : murs en parpaings, pignons, ouvertures et poutre de façade réalisés par DMZ Normandie.",
    subtitle: "La maçonnerie complète d'une maison : murs, pignons, ouvertures et poutre de façade.",
    description: "Ce chantier de Louviers présente l'élévation d'une maison en parpaings. Les murs, pignons, linteaux et la poutre de façade ont été réalisés avec un contrôle régulier des niveaux et des alignements.",
    materiaux: ["Parpaings", "Béton", "Linteaux", "Ferraillage"],
    etapes: ["Préparation des fondations et de la dalle", "Élévation des murs en parpaings", "Mise en place des linteaux", "Réalisation de la poutre de façade", "Montage des pignons et finitions"],
    photos: [
      { img: "/realisations/maison-parpaing-louviers.webp", alt: "Maison en parpaings construite à Louviers par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "fondations", "maconnerie-louviers"],
    villesProches: ["Évreux", "Vernon", "sud de l'Eure"],
  },
  "allee-paves-conches-en-ouche": {
    slug: "allee-paves-conches-en-ouche",
    ville: "Conches-en-Ouche",
    titre: "Allée en pavés à Conches-en-Ouche",
    seoTitle: "Allée en pavés à Conches-en-Ouche | Extérieurs – DMZ Normandie",
    seoDesc: "Pose réelle d'une allée en pavés avec bordures béton à Conches-en-Ouche par DMZ Normandie. Devis gratuit dans l'Eure.",
    subtitle: "Une allée extérieure posée sur lit préparé, avec des bordures béton pour une finition durable.",
    description: "À Conches-en-Ouche, nous avons préparé le lit de pose, installé les bordures béton puis posé les pavés de l'allée. Le chantier montre un aménagement extérieur propre et structuré.",
    materiaux: ["Pavés", "Bordures béton", "Lit de pose"],
    etapes: ["Préparation et compactage du support", "Pose des bordures béton", "Mise en place du lit de pose", "Pose des pavés", "Réglages et finitions des abords"],
    photos: [
      { img: "/realisations/paves-conches-en-ouche.webp", alt: "Allée en pavés posée à Conches-en-Ouche par DMZ Normandie" },
    ],
    services: ["beton-amenagements-exterieurs", "dalles-beton", "maconnerie-conches-en-ouche"],
    villesProches: ["Le Neubourg", "Louviers", "centre de l'Eure"],
  },
  "gros-oeuvre-pont-audemer": {
    slug: "gros-oeuvre-pont-audemer",
    ville: "Pont-Audemer",
    titre: "Gros œuvre d'une maison à double pignon à Pont-Audemer",
    seoTitle: "Gros œuvre à Pont-Audemer | Maison double pignon – DMZ Normandie",
    seoDesc: "Chantier réel à Pont-Audemer : fondations, élévation en parpaings, double pignon et ouvertures réalisés par DMZ Normandie.",
    subtitle: "Une maison montée en parpaings jusqu'aux pignons, prête pour l'étape de charpente.",
    description: "À Pont-Audemer, DMZ Normandie a réalisé le gros œuvre complet d'une maison à double pignon : fondations, élévation des murs, ouvertures et pignons en parpaings.",
    materiaux: ["Parpaings", "Béton", "Ferraillage", "Linteaux"],
    etapes: ["Préparation des fondations", "Réglage des niveaux", "Élévation des murs en parpaings", "Réalisation des ouvertures et linteaux", "Montage des deux pignons"],
    photos: [
      { img: "/realisations/gros-oeuvre-pignons-pont-audemer.webp", alt: "Gros œuvre d'une maison à double pignon à Pont-Audemer par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "fondations", "maconnerie-pont-audemer"],
    villesProches: ["Beuzeville", "ouest de l'Eure", "Pays d'Auge"],
  },
  "elevation-poutre-thiberville": {
    slug: "elevation-poutre-thiberville",
    ville: "Thiberville",
    titre: "Élévation de murs et poutre béton à Thiberville",
    seoTitle: "Gros œuvre à Thiberville | Murs & poutre béton – DMZ Normandie",
    seoDesc: "Élévation réelle de murs en parpaings à Thiberville avec coffrage et coulage d'une grande poutre béton par DMZ Normandie.",
    subtitle: "Des murs montés en parpaings avec une poutre béton coffrée et coulée sur place.",
    description: "Ce chantier de Thiberville montre l'élévation de murs en parpaings et la réalisation d'une grande poutre béton de chaînage. Le coffrage et le coulage ont été réalisés par nos soins.",
    materiaux: ["Parpaings", "Béton", "Coffrage", "Ferraillage"],
    etapes: ["Préparation des murs et des niveaux", "Élévation en parpaings", "Mise en place du coffrage", "Ferraillage et coulage de la poutre", "Contrôle et finition du chaînage"],
    photos: [
      { img: "/realisations/elevation-poutre-thiberville.webp", alt: "Élévation de murs avec poutre béton à Thiberville par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "construction-murs", "maconnerie-thiberville"],
    villesProches: ["Bernay", "Fontaine-l'Abbé", "ouest bernayen"],
  },
  "gros-oeuvre-deauville": {
    slug: "gros-oeuvre-deauville",
    ville: "Deauville",
    titre: "Gros œuvre d'une maison à Deauville",
    seoTitle: "Gros œuvre à Deauville | Dalles & murs parpaings – DMZ Normandie",
    seoDesc: "Vue réelle d'un chantier à Deauville : fondations, dalles béton et élévation des murs en parpaings par DMZ Normandie.",
    subtitle: "Une vue aérienne du chantier : dalles coulées et murs en parpaings en cours d'élévation.",
    description: "À Deauville, DMZ Normandie a réalisé les fondations, les dalles béton et l'élévation des murs en parpaings d'une maison. La photo aérienne montre clairement l'avancement réel du gros œuvre.",
    materiaux: ["Béton", "Parpaings", "Ferraillage"],
    etapes: ["Préparation du terrain", "Réalisation des fondations", "Coulage des dalles béton", "Élévation des murs en parpaings", "Contrôle des niveaux et des ouvertures"],
    photos: [
      { img: "/realisations/gros-oeuvre-deauville.webp", alt: "Gros œuvre vu du ciel à Deauville par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "dalles-beton", "maconnerie-deauville"],
    villesProches: ["Côte Fleurie", "Pont-Audemer", "Beuzeville"],
  },
  "terrasse-beton-lissee-eure": {
    slug: "terrasse-beton-lissee-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Terrasse en béton lissé dans l'Eure",
    seoTitle: "Terrasse béton lissé dans l'Eure | DMZ Normandie",
    seoDesc: "Chantier réel dans l'Eure : préparation, coffrage, ferraillage, coulage et finition lissée d'une terrasse béton par DMZ Normandie.",
    subtitle: "Une terrasse béton préparée et coulée pour créer un espace extérieur durable et esthétique.",
    description: "Ce chantier montre la réalisation complète d'une terrasse en béton lissé. La préparation du support, le coffrage et la finition ont été soignés pour obtenir une surface plane et durable.",
    materiaux: ["Béton", "Ferraillage", "Coffrage"],
    etapes: ["Préparation et réglage du terrain", "Mise en place du coffrage", "Ferraillage de la dalle", "Coulage du béton", "Lissage et finition des bords"],
    photos: [
      { img: "/realisations/terrasse-maison-beton.webp", alt: "Terrasse en béton lissé réalisée par DMZ Normandie dans l'Eure" },
    ],
    services: ["dalles-beton", "beton-amenagements-exterieurs", "fondations"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "elevation-pignons-parpaing-eure": {
    slug: "elevation-pignons-parpaing-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Élévation de murs et pignons en parpaings",
    seoTitle: "Élévation murs et pignons dans l'Eure | DMZ Normandie",
    seoDesc: "Montage réel de murs et pignons en parpaings dans l'Eure : linteaux, chaînages et ouvertures réalisés par DMZ Normandie.",
    subtitle: "Le montage des murs et pignons d'une construction neuve en parpaings.",
    description: "Cette réalisation présente l'élévation des murs et des pignons d'une construction neuve. Les linteaux, chaînages et ouvertures ont été réalisés avec un contrôle régulier des niveaux.",
    materiaux: ["Parpaings", "Béton", "Linteaux", "Ferraillage"],
    etapes: ["Contrôle de l'implantation", "Montage des murs en parpaings", "Mise en place des linteaux", "Réalisation des chaînages", "Montage et finition des pignons"],
    photos: [
      { img: "/realisations/pignons-parpaing.webp", alt: "Élévation de murs en parpaings avec pignons par DMZ Normandie dans l'Eure" },
    ],
    services: ["gros-oeuvre", "construction-murs", "fondations"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "mur-cloture-portail-eure": {
    slug: "mur-cloture-portail-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Mur de clôture et pilier de portail dans l'Eure",
    seoTitle: "Mur de clôture dans l'Eure | Pilier portail – DMZ Normandie",
    seoDesc: "Construction réelle d'un mur de clôture avec pilier de portail dans l'Eure : fondations, montage et finition par DMZ Normandie.",
    subtitle: "Une clôture maçonnée pour délimiter et sécuriser durablement la propriété.",
    description: "DMZ Normandie a réalisé les fondations, le montage du mur de clôture et le pilier de portail. La finition extérieure donne une clôture propre et durable.",
    materiaux: ["Parpaings", "Béton de fondation", "Enduit de finition"],
    etapes: ["Implantation de la clôture", "Réalisation des fondations", "Montage du mur", "Construction du pilier de portail", "Application de l'enduit de finition"],
    photos: [
      { img: "/realisations/mur-cloture-portail.webp", alt: "Mur de clôture et pilier de portail maçonnés par DMZ Normandie dans l'Eure" },
    ],
    services: ["construction-murs", "maconnerie-bernay", "beton-amenagements-exterieurs"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "gros-oeuvre-batiment-eure": {
    slug: "gros-oeuvre-batiment-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Gros œuvre d'un bâtiment dans l'Eure",
    seoTitle: "Gros œuvre bâtiment dans l'Eure | DMZ Normandie",
    seoDesc: "Structure réelle d'un bâtiment dans l'Eure : fondations, murs porteurs, poutres et ouvrages béton par DMZ Normandie.",
    subtitle: "La structure complète d'un bâtiment : murs porteurs et ouvrages en béton.",
    description: "Ce chantier présente le gros œuvre d'un bâtiment, de la préparation des fondations à l'élévation des murs porteurs et aux ouvrages béton nécessaires à la structure.",
    materiaux: ["Parpaings", "Béton", "Ferraillage", "Coffrage"],
    etapes: ["Préparation des fondations", "Réglage des niveaux", "Élévation des murs porteurs", "Réalisation des poutres et ouvrages béton", "Contrôle de la structure"],
    photos: [
      { img: "/realisations/gros-oeuvre-batiment.webp", alt: "Gros œuvre d'un bâtiment en parpaings réalisé par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "fondations", "construction-murs"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "mur-parpaing-interieur-eure": {
    slug: "mur-parpaing-interieur-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Mur intérieur en parpaings dans l'Eure",
    seoTitle: "Mur parpaing intérieur dans l'Eure | DMZ Normandie",
    seoDesc: "Montage réel d'un mur intérieur en parpaings dans l'Eure : mortier, joints réguliers et contrôle d'aplomb par DMZ Normandie.",
    subtitle: "Un mur intérieur monté au mortier avec des joints réguliers et un contrôle d'aplomb.",
    description: "Cette réalisation montre le montage précis d'un mur intérieur en parpaings. Chaque rang est contrôlé pour obtenir un ouvrage droit, stable et propre.",
    materiaux: ["Parpaings", "Mortier"],
    etapes: ["Traçage de l'emplacement", "Préparation du premier rang", "Montage au mortier", "Contrôle d'aplomb et de niveau", "Réalisation des joints"],
    photos: [
      { img: "/realisations/mur-parpaing-interieur.webp", alt: "Montage d'un mur intérieur en parpaings par DMZ Normandie" },
    ],
    services: ["construction-murs", "maconnerie-bernay", "gros-oeuvre"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "terrasse-beton-finition-eure": {
    slug: "terrasse-beton-finition-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Terrasse béton avec finition soignée dans l'Eure",
    seoTitle: "Terrasse béton dans l'Eure | Finition soignée – DMZ Normandie",
    seoDesc: "Terrasse béton réelle dans l'Eure : terrassement, coffrage, coulage et lissage pour des bords propres et une surface plane.",
    subtitle: "Une surface béton plane avec des bords propres, préparée pour l'aménagement extérieur.",
    description: "Ce chantier présente une terrasse en béton coulée et lissée avec une attention particulière portée aux bords, à la planéité et à la finition de surface.",
    materiaux: ["Béton", "Coffrage", "Ferraillage"],
    etapes: ["Terrassement et compactage", "Mise en place du coffrage", "Préparation et ferraillage", "Coulage du béton", "Lissage et finition des rives"],
    photos: [
      { img: "/realisations/terrasse-beton.webp", alt: "Terrasse en béton lissé coulée par DMZ Normandie" },
    ],
    services: ["dalles-beton", "beton-amenagements-exterieurs", "fondations"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "construction-maison-contemporaine-eure": {
    slug: "construction-maison-contemporaine-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Construction d'une maison contemporaine dans l'Eure",
    seoTitle: "Construction maison contemporaine dans l'Eure | DMZ Normandie",
    seoDesc: "Gros œuvre et maçonnerie réels d'une maison contemporaine dans l'Eure : fondations, murs et dalles par DMZ Normandie.",
    subtitle: "Le gros œuvre et la maçonnerie d'une maison contemporaine.",
    description: "Cette réalisation illustre les travaux de gros œuvre d'une maison contemporaine : fondations, dalles et murs réalisés dans un ordre rigoureux pour préparer la suite du chantier.",
    materiaux: ["Béton", "Parpaings", "Ferraillage"],
    etapes: ["Préparation du terrain", "Réalisation des fondations", "Coulage de la dalle", "Élévation des murs", "Contrôle des niveaux et ouvertures"],
    photos: [
      { img: "/realisations/maison-contemporaine.webp", alt: "Construction neuve contemporaine réalisée par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "fondations", "dalles-beton"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "renovation-facade-brique-silex-eure": {
    slug: "renovation-facade-brique-silex-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Rénovation de façade en brique et silex dans l'Eure",
    seoTitle: "Rénovation façade brique silex dans l'Eure | DMZ Normandie",
    seoDesc: "Rénovation réelle d'une maçonnerie traditionnelle en brique et silex : reprise, rejointoiement et enduits par DMZ Normandie.",
    subtitle: "La rénovation d'une maçonnerie traditionnelle en brique et silex.",
    description: "Ce chantier présente la rénovation d'une façade traditionnelle mêlant brique et silex. Les reprises de maçonnerie, le rejointoiement et les enduits ont été réalisés en respectant l'aspect du bâti.",
    materiaux: ["Brique", "Silex", "Mortier de rejointoiement", "Enduit"],
    etapes: ["Diagnostic de la façade", "Préparation du support", "Reprise des zones de maçonnerie", "Rejointoiement", "Application et finition des enduits"],
    photos: [
      { img: "/realisations/facade-brique-silex.webp", alt: "Rénovation et rejointoiement d'une façade en brique et silex par DMZ Normandie" },
    ],
    services: ["rejointoiement", "renovation-bernay", "construction-murs"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "construction-maison-plain-pied-eure": {
    slug: "construction-maison-plain-pied-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Maison plain-pied et allée pavée dans l'Eure",
    seoTitle: "Maison plain-pied et allée pavée dans l'Eure | DMZ Normandie",
    seoDesc: "Construction réelle d'une maison plain-pied dans l'Eure avec gros œuvre, allée en pavés et bordures par DMZ Normandie.",
    subtitle: "La construction d'une maison plain-pied et l'aménagement de son extérieur.",
    description: "Cette réalisation regroupe le gros œuvre d'une maison plain-pied et l'aménagement extérieur avec une allée en pavés et ses bordures, pour un ensemble cohérent et durable.",
    materiaux: ["Parpaings", "Béton", "Pavés", "Bordures"],
    etapes: ["Préparation des fondations", "Élévation des murs de la maison", "Réalisation des dalles", "Préparation de l'allée", "Pose des pavés et des bordures"],
    photos: [
      { img: "/realisations/maison-plain-pied.webp", alt: "Maison plain-pied avec allée pavée réalisée par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "beton-amenagements-exterieurs", "fondations"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "garage-carport-eure": {
    slug: "garage-carport-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Garage et carport dans l'Eure",
    seoTitle: "Construction garage et carport dans l'Eure | DMZ Normandie",
    seoDesc: "Extension réelle avec garage et carport dans l'Eure : fondations, murs et dalle béton réalisés par DMZ Normandie.",
    subtitle: "La construction d'un garage avec un carport attenant.",
    description: "Ce chantier présente la construction d'un garage et de son carport attenant. Les fondations, les murs et la dalle béton ont été réalisés pour créer une extension pratique et durable.",
    materiaux: ["Parpaings", "Béton", "Enduit"],
    etapes: ["Implantation de l'extension", "Réalisation des fondations", "Coulage de la dalle", "Montage des murs du garage", "Finitions extérieures"],
    photos: [
      { img: "/realisations/garage-carport.webp", alt: "Garage et carport construits par DMZ Normandie" },
    ],
    services: ["extension-maison", "gros-oeuvre", "dalles-beton"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "gros-oeuvre-maison-individuelle-eure": {
    slug: "gros-oeuvre-maison-individuelle-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Gros œuvre d'une maison individuelle dans l'Eure",
    seoTitle: "Gros œuvre maison individuelle dans l'Eure | DMZ Normandie",
    seoDesc: "Élévation réelle des murs d'une maison neuve dans l'Eure : linteaux, chaînages et ouvertures par DMZ Normandie.",
    subtitle: "L'élévation complète des murs d'une maison neuve sur dalle béton.",
    description: "Ce chantier montre l'élévation complète des murs d'une maison individuelle : parpaings, linteaux, chaînages et ouvertures réalisés sur dalle béton.",
    materiaux: ["Parpaings", "Béton", "Linteaux", "Ferraillage"],
    etapes: ["Contrôle de la dalle et des implantations", "Montage des murs", "Mise en place des linteaux", "Réalisation des chaînages", "Contrôle des ouvertures"],
    photos: [
      { img: "/realisations/gros-oeuvre-maison.webp", alt: "Gros œuvre d'une maison individuelle en parpaings par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "construction-murs", "dalles-beton"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "batiment-brique-professionnel-eure": {
    slug: "batiment-brique-professionnel-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Bâtiment professionnel en brique dans l'Eure",
    seoTitle: "Bâtiment brique professionnel dans l'Eure | DMZ Normandie",
    seoDesc: "Construction réelle d'un bâtiment professionnel en brique dans l'Eure : maçonnerie, façades et ouvrages béton par DMZ Normandie.",
    subtitle: "La construction d'un bâtiment professionnel en brique, façades et structure.",
    description: "Cette réalisation présente la maçonnerie d'un bâtiment professionnel en brique. Les façades, la structure et les ouvrages béton associés ont été réalisés avec soin.",
    materiaux: ["Brique", "Béton", "Mortier", "Ferraillage"],
    etapes: ["Préparation des fondations", "Montage des murs en brique", "Réalisation des ouvrages béton", "Construction des façades", "Contrôle des alignements et finitions"],
    photos: [
      { img: "/realisations/batiment-brique-chantier.webp", alt: "Construction d'un bâtiment en brique par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "construction-murs", "parement-brique"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "elevation-maison-plain-pied-eure": {
    slug: "elevation-maison-plain-pied-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Élévation d'une maison plain-pied dans l'Eure",
    seoTitle: "Élévation maison plain-pied dans l'Eure | DMZ Normandie",
    seoDesc: "Montage réel des murs d'une maison plain-pied dans l'Eure : parpaings, linteaux et chaînages par DMZ Normandie.",
    subtitle: "Le montage des murs d'une maison plain-pied avec ses ouvertures.",
    description: "Ce chantier présente l'élévation en parpaings d'une maison plain-pied. Les murs, linteaux et chaînages sont réalisés avec un contrôle régulier des alignements.",
    materiaux: ["Parpaings", "Linteaux", "Béton", "Ferraillage"],
    etapes: ["Préparation des premiers rangs", "Élévation des murs", "Mise en place des linteaux", "Réalisation des chaînages", "Contrôle des ouvertures et niveaux"],
    photos: [
      { img: "/realisations/maison-parpaing-plain-pied.webp", alt: "Élévation d'une maison plain-pied en parpaings par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "construction-murs", "fondations"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "vide-sanitaire-parpaing-eure": {
    slug: "vide-sanitaire-parpaing-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Vide sanitaire et soubassements dans l'Eure",
    seoTitle: "Vide sanitaire en parpaings dans l'Eure | DMZ Normandie",
    seoDesc: "Montage réel de soubassements et d'un vide sanitaire en parpaings dans l'Eure par DMZ Normandie, après fondations.",
    subtitle: "Le montage des soubassements et du vide sanitaire d'une construction neuve.",
    description: "Cette réalisation montre la construction des soubassements en parpaings et du vide sanitaire d'une maison. Cette étape prépare la dalle et protège la structure.",
    materiaux: ["Parpaings", "Béton", "Mortier"],
    etapes: ["Réalisation des fondations", "Réglage des niveaux", "Montage des soubassements", "Constitution du vide sanitaire", "Préparation avant la dalle"],
    photos: [
      { img: "/realisations/vide-sanitaire-parpaing.webp", alt: "Vide sanitaire et soubassements en parpaings par DMZ Normandie" },
    ],
    services: ["fondations", "gros-oeuvre", "construction-murs"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
  "batiment-cour-beton-eure": {
    slug: "batiment-cour-beton-eure",
    ville: "Eure",
    localisation: "Dans l'Eure",
    zonePhrase: "dans l'Eure",
    titre: "Bâtiment et cour en béton dans l'Eure",
    seoTitle: "Bâtiment et cour béton dans l'Eure | DMZ Normandie",
    seoDesc: "Structure réelle en parpaings avec cour en béton dans l'Eure : murs, ouvrages béton et dalle extérieure par DMZ Normandie.",
    subtitle: "La structure en parpaings d'un bâtiment avec sa cour en béton.",
    description: "Ce chantier combine l'élévation des murs en parpaings d'un bâtiment et la réalisation d'une cour en béton. Les ouvrages intérieurs et extérieurs ont été coordonnés pour obtenir un ensemble cohérent.",
    materiaux: ["Parpaings", "Béton", "Ferraillage"],
    etapes: ["Préparation des fondations", "Élévation des murs", "Réalisation des ouvrages béton", "Préparation de la cour", "Coulage et finition de la dalle extérieure"],
    photos: [
      { img: "/realisations/gros-oeuvre-cour.webp", alt: "Gros œuvre d'un bâtiment avec cour en béton par DMZ Normandie" },
    ],
    services: ["gros-oeuvre", "dalles-beton", "beton-amenagements-exterieurs"],
    villesProches: ["Bernay", "Évreux", "Normandie"],
  },
};

export const CHANTIER_BY_IMAGE = Object.values(CHANTIERS).reduce((acc, chantier) => {
  chantier.photos.forEach((photo) => {
    acc[photo.img] = chantier;
  });
  return acc;
}, {});
